import { render, staticRenderFns } from "./LocalFlow.vue?vue&type=template&id=6b2ead02&scoped=true"
import script from "./LocalFlow.vue?vue&type=script&lang=js"
export * from "./LocalFlow.vue?vue&type=script&lang=js"
import style0 from "./LocalFlow.vue?vue&type=style&index=0&id=6b2ead02&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b2ead02",
  null
  
)

export default component.exports